import { render, staticRenderFns } from "./unvisits.vue?vue&type=template&id=27f2521a&scoped=true"
import script from "./unvisits.vue?vue&type=script&lang=js"
export * from "./unvisits.vue?vue&type=script&lang=js"
import style0 from "./unvisits.vue?vue&type=style&index=0&id=27f2521a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2521a",
  null
  
)

export default component.exports